import React from 'react';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export const createTabId = (index: number) => `admin-tab-${index}`;
export const createTabPanelId = (index: number) => `admin-tabpanel-${index}`;

export const TabsPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={createTabPanelId(index)}
            aria-labelledby={createTabId(index)}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
};
